import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { capitalizeFirstLetterOfEachWord } from "../../../Components/Functions/word.fun";
import { useSelector, useDispatch } from "react-redux";
import { BsCheckCircleFill } from "react-icons/bs";
import { FcCalendar } from "react-icons/fc";
import { GoIssueReopened } from "react-icons/go";
import { MdOutlineDelete, MdOutlineFeedback } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { extractDate } from "../../../Components/Functions/date.fun";
import { fetchTaskCounts } from "../../../redux/Task/taskReducer";

const ViewTasks = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [lastThreeData, setLastThhreeData] = useState();
  const [showReply, setShowReply] = useState(false);
  const [reply, setReply] = useState("");
  const [evidenceFile, setEvidenceFile] = useState(null);
  const [evidenceLink, setEvidenceLink] = useState("");
  const user = useSelector((store) => store.login.user);
  let { id } = useParams();
  const [userData, setUserData] = useState();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/tasks/getTaskManagementById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Tasks!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/tasks/checkLastThreeTasks/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setLastThhreeData(res.data);
        } else {
          Toast("error", "Error while getting Tasks!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  // const markasCompleted = () => {
  //   setLoading(true);
  //   const currentDate = new Date();
  //   const completedTime = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);

  //   performRequest("PATCH", `/tasks/updateMarkAsCompleted/${id}`, {
  //     status: "completed",
  //     completedTime: completedTime.toISOString(),
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         Toast("success", "Task marked as completed!");
  //         navigate(`/`);
  //       } else {
  //         Toast("error", "Error while Creating");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     })
  //     .finally(() => setLoading(false));
  // };

  const markasCompleted = async () => {
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("status", "completed");

      const currentDate = new Date();
      const completedTime = new Date(
        currentDate.getTime() + 24 * 60 * 60 * 1000
      );

      formData.append("completedTime", completedTime.toISOString());

      if (evidenceFile) {
        formData.append("evidenceUpload", evidenceFile); // 👈 MUST MATCH multer
      }

      if (evidenceLink) {
        formData.append("evidenceLink", evidenceLink);
      }

      const res = await performRequest(
        "PATCH",
        `/tasks/updateMarkAsCompleted/${id}`,
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      );

      if (res.status === 200) {
        Toast("success", "Task marked as completed!");
        dispatch(fetchTaskCounts()); // ✅ ADD THIS
        navigate(`/`);
      } else {
        Toast("error", "Error while updating");
      }
    } catch (err) {
      CustomErrorResponse(err);
    } finally {
      setLoading(false);
    }
  };

  const reopenTask = () => {
    performRequest("PATCH", `/tasks/reopenTask/${id}`, {
      status: "pending",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Task reopen successfuly!");
          dispatch(fetchTaskCounts()); // ✅ ADD THIS
          navigate(`/task-management`);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    performRequest("GET", "/login/alllogin/")
      .then((res) => {
        if (res.status === 201) {
          setUserData(res.data?.leads);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const getNameById = (id) => {
    if (!id || !userData) {
      return "N/A";
    }
    const user = userData.find((user) => user.id === id);
    return user ? user.userName : "N/A";
  };

  const handleAddResponse = () => {
    const updatedReplies = [
      ...(data?.feedbackReplies || []),
      {
        userId: user.UserId,
        name: user.Name,
        message: reply,
        createdAt: new Date(),
      },
    ];
    const values = { feedbackReplies: updatedReplies };

    setLoading(true);
    performRequest("PATCH", `/tasks/updateTaskManagement/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Feedback added successfully!");
          setData((prevData) => ({
            ...prevData,
            feedbackReplies: updatedReplies,
          }));
          setReply("");
          setShowReply(false);
        } else {
          Toast("error", "Error while adding response");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    performRequest("DELETE", `/tasks/deleteTaskManagementById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Task Deleted Successfuly!");
          dispatch(fetchTaskCounts()); // ✅ ADD THIS
          navigate(`/task-management`);
        } else {
          Toast("error", "Error while Deleting");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const formattedText = data?.description.split(urlRegex).map((part, index) => {
    if (part.match(urlRegex)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "blue", textDecoration: "underline" }}
        >
          {part}
        </a>
      );
    }
    return <span key={index}>{part}</span>;
  });

  const isEvidenceValid = evidenceFile || evidenceLink?.trim() !== "";

  const isImage = (url) => {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2  me-1" /> View Task
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Update & Track Task.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  {data?.status === "completed" && (
                    <button onClick={reopenTask} className="btn btn-primary">
                      <GoIssueReopened className="me-2" /> REOPEN TASK
                    </button>
                  )}
                  {data?.status === "pending" ? (
                    <button
                      onClick={markasCompleted}
                      className="btn btn-primary"
                      disabled={!isEvidenceValid}
                    >
                      <BsCheckCircleFill className="me-2" /> MARK AS COMPLETED
                    </button>
                  ) : (
                    <button className="btn btn-primary" disabled>
                      <BsCheckCircleFill className="me-2" /> TASK COMPLETED
                    </button>
                  )}
                  {data?.status === "pending" && !isEvidenceValid && (
                    <small className="text-danger">
                      Please upload evidence or provide a link before completing
                      the task
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>
                  Give appropriate feedback on the task once task is completed.
                </p>
                <p>
                  You can reopen the task by giving the feedback if the output
                  is not as per desire.
                </p>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Task Spec</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && (
                        <tr>
                          <td class="text-secondary">Task Name</td>
                          <td>
                            {capitalizeFirstLetterOfEachWord(data?.name) ||
                              "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td class="text-secondary">Task Description</td>
                          <td>
                            {/* {capitalizeFirstLetterOfEachWord(
                              data?.description
                            ) || "N/A"} */}
                            {formattedText}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td class="text-secondary">Task Assigned To</td>
                          <td>
                            {capitalizeFirstLetterOfEachWord(data?.assignTo) ||
                              "N/A"}
                          </td>
                        </tr>
                      )}
                      {data?.taskType !== "" && (
                        <tr>
                          <td class="text-secondary">Task Type</td>
                          <td>
                            {capitalizeFirstLetterOfEachWord(data?.taskType) ||
                              "N/A"}
                          </td>
                        </tr>
                      )}
                      {data?.deadline !== "" && (
                        <tr>
                          <td class="text-secondary">Task Deadline</td>
                          <td>{data?.deadline || "N/A"}</td>
                        </tr>
                      )}
                      {data?.startDate !== "" && (
                        <tr>
                          <td class="text-secondary">Task Start Date</td>
                          <td>{data?.startDate || "N/A"}</td>
                        </tr>
                      )}
                      {data?.endDate !== "" &&
                        data?.taskType === "repeat task" && (
                          <tr>
                            <td class="text-secondary">Task End Date</td>
                            <td>{data?.endDate || "N/A"}</td>
                          </tr>
                        )}
                      {data?.frequency !== "" && (
                        <tr>
                          <td class="text-secondary">Task Frequency</td>
                          <td>
                            {data?.frequency}{" "}
                            {capitalizeFirstLetterOfEachWord(
                              data?.frequencyType
                            )}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td class="text-secondary">Task Status</td>
                          <td>
                            {capitalizeFirstLetterOfEachWord(data?.status) ||
                              "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td class="text-secondary">Generated By</td>
                          <td>{getNameById(data?.generatedBy)}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td class="text-secondary">Priority</td>
                          <td>
                            {capitalizeFirstLetterOfEachWord(data?.priority) ||
                              "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td class="text-secondary">Task Difficulty</td>
                          <td>
                            {capitalizeFirstLetterOfEachWord(
                              data?.taskDifficulty
                            ) || "N/A"}
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td class="text-secondary">Evidence Upload</td>
                        <td>
                          {data?.status === "pending" ? (
                            <>
                              {/* File Upload */}
                              <input
                                type="file"
                                className="form-control mb-2"
                                onChange={(e) =>
                                  setEvidenceFile(e.target.files[0])
                                }
                              />

                              {/* OR Link Input */}
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Paste link (Google Drive, Loom, etc.)"
                                value={evidenceLink}
                                onChange={(e) =>
                                  setEvidenceLink(e.target.value)
                                }
                              />
                            </>
                          ) : (
                            <>
                              {/* ✅ COMPLETED CASE */}
                              {data?.evidenceUpload ? (
                                <div className="d-flex flex-column align-items-start gap-2">
                                  {isImage(data.evidenceUpload) ? (
                                    <>
                                      <img
                                        src={data.evidenceUpload}
                                        alt="Evidence"
                                        style={{
                                          maxWidth: "200px",
                                          borderRadius: "8px",
                                          border: "1px solid #ddd",
                                        }}
                                      />

                                      <a
                                        href={data.evidenceUpload}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-outline-primary"
                                      >
                                        Open Full Image
                                      </a>
                                    </>
                                  ) : (
                                    <a
                                      href={data.evidenceUpload}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-primary text-break"
                                    >
                                      {data.evidenceUpload}
                                    </a>
                                  )}
                                </div>
                              ) : (
                                <span className="text-muted">
                                  No evidence provided
                                </span>
                              )}
                            </>
                          )}
                        </td>
                      </tr>

                      {data?.uploadImage && (
                        <tr>
                          <td class="text-secondary">Reference image</td>
                          <td>
                            {data?.uploadImage && (
                              <img
                                src={data?.uploadImage}
                                alt="Task reference"
                                style={{ height: "200px", width: "200px" }}
                              ></img>
                            )}
                          </td>
                        </tr>
                      )}
                      {data?.taskType === "repeat task" && (
                        <h3 className="mt-3 mb-2 ms-3">Last 3 Activities</h3>
                      )}
                    </tbody>
                  </table>
                  {data?.taskType === "repeat task" && (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Evidance Upload</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lastThreeData?.logs?.map((data, index) => (
                          <tr key={index}>
                            <td className="text-secondary">
                              {extractDate(data?.createdAt)}
                            </td>
                            <td>
                              {data?.status === "markAsNotCompleted" ? (
                                <span className="badge bg-danger text-white">
                                  Not Completed
                                </span>
                              ) : (
                                <span className="badge bg-success text-white">
                                  Completed
                                </span>
                              )}
                            </td>
                            <td>
                              {data?.status === "markAsNotCompleted" ? (
                                <span className="badge bg-danger text-white">
                                  Not Completed
                                </span>
                              ) : (
                                <span>
                                  <a
                                    href={data.evidenceUpload}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary text-break"
                                  >
                                    {data.evidenceUpload}
                                  </a>
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                {data && (
                  <>
                    <div className="row p-3">
                      <label className="w-25 form-label col-3">Feedback</label>
                      <div className="w-100 col">
                        {data?.feedbackReplies &&
                        data?.feedbackReplies?.length > 0
                          ? data?.feedbackReplies?.map(
                              (feedbackReplies, index) => (
                                <div key={index} className="card my-2">
                                  <div className="card-body">
                                    {feedbackReplies?.name && (
                                      <div className="d-flex">
                                        <FaUserCircle
                                          className="me-2"
                                          style={{ fontSize: "25px" }}
                                        />
                                        <h5 className="card-title">
                                          {feedbackReplies?.name}
                                        </h5>
                                      </div>
                                    )}
                                    <p
                                      className="card-text"
                                      style={{ whiteSpace: "pre-wrap" }}
                                    >
                                      {feedbackReplies?.message}
                                    </p>
                                    <p className="card-text">
                                      <small className="text-muted">
                                        {new Date(
                                          feedbackReplies?.createdAt
                                        ).toLocaleString()}
                                      </small>
                                    </p>
                                  </div>
                                </div>
                              )
                            )
                          : "No feedback yet"}
                      </div>
                    </div>

                    {showReply ? (
                      <div className="row p-3">
                        <label className="w-25 form-label col-3">
                          Your Feedback
                        </label>
                        <div className="w-100 col">
                          <textarea
                            className="form-control"
                            value={reply}
                            onChange={(e) => setReply(e.target.value)}
                            rows="3"
                          ></textarea>
                          <button
                            onClick={handleAddResponse}
                            className="btn btn-primary mt-2"
                          >
                            Submit
                          </button>
                          <button
                            onClick={() => setShowReply(false)}
                            className="btn btn-secondary mt-2 ms-2"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="row p-3">
                        <div className="w-100 col">
                          <button
                            onClick={() => setShowReply(true)}
                            className="btn btn-primary"
                          >
                            <MdOutlineFeedback className="me-2" />
                            Give Feedback
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}

                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    {(user.UserId == data?.generatedBy ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN_S) && (
                      <SimpleButton
                        buttonText="Edit Task"
                        href={`/task-management/edit/${id}`}
                      />
                    )}
                    {(user.UserId == data?.generatedBy ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN_S) && (
                      <button
                        className="btn mx-1 mt-2 btn-danger"
                        onClick={() => handleDelete(data?.id)}
                      >
                        <MdOutlineDelete className="fs-2 me-1" />
                        DELETE TASK
                      </button>
                    )}
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewTasks;
